import { Injectable } from '@angular/core';
import { Constant } from 'src/app/constant/constant';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NavigationExtras, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { EcryptServiceService } from '../core/auth/EcryptionService/ecrypt-service.service';
import { ResourceAccess } from '../shared/utils/calsoft-validators';

export const CURRENCY = 'currency';

@Injectable({
	providedIn: 'root'
})
export class CommonService {


	isLoading1 = new BehaviorSubject<boolean>(false);

	show() {
		this.isLoading1.next(true);
	}

	hide() {
		this.isLoading1.next(false);
	}

	constructor(private http: HttpClient,
		private router: Router,
		private ecryptServiceService: EcryptServiceService,) {

		window.addEventListener('storage', (event) => {
			if (event.key === 'baseUrl') {
				this.baseUrlSubject.next(event.newValue || '');
			}
		});
	}

	url = environment.serverAPI4 + '/api';
	url1 = environment.serverAPI + '/api';
	url2 = environment.serverAPI4 + '/api/catalog';
	url4 = environment.serverAPI9 + '/api/ig/facebook/oauth/exchange';
	url5 = environment.serverAPI9 + '/api';
	url6 = environment.serverAPI8 + '/api';
	url7 = environment.serverAPI9 + '/api/docusign/token';

	urlNew = 'https://app.flowzo.ai/ecom-gateway/ecom-svc-crm-1.0-SNAPSHOT/api';

	setCurrencyValue(value) {
		localStorage.setItem(CURRENCY, value);
	}

	getCurrencyValue() {
		return localStorage.getItem(CURRENCY);
	}

	productSearch(name: any) {
		const navigationExtras: NavigationExtras = {
			queryParams: {
				// "page":Constant.DEFAULT_PAGE_SIZE,
				'sid': this.ecryptServiceService.encryptionAES(name),
			},
		};
		name = name.replace(/\//g, "FWDSLS")
		name = name.replace(/\s/g, "_");
		//name = name.replace(/"/g, '&');
		name = name.replace(/®/g, 'Ro');
		name = name.replace(/\(/g, 'BRS');
		name = name.replace(/\)/g, 'BREl3jk875');

		// name= name.replace(/"/g, "Por21Ld245");
		this.router.navigate([`search/${name}`], navigationExtras);
	}

	getCountry(): Observable<Object> {
		return this.http.get(`${this.url}/country`);
	}

	getCustomResource(): Observable<Object> {
		return this.http.get(`${this.url}/product/custom/list`);
	}

	getCountryList(): Observable<Object> {
		return this.http.get(`${this.url}/countryList`);
	}

	getCountryListNew(): Observable<Object> {
		return this.http.get(`${this.url}/config/country/all?page=0&size=256`);
	}

	getAuditData(auditType, entityId): Observable<Object> {
		return this.http.get(`${this.url}/audit/${auditType}/${entityId}`);
	}

	downloadaudit(auditType, entityId): Observable<any> {
		return this.http.get(`${this.url}/audit/export/${auditType}/${entityId}`, { responseType: 'arraybuffer', observe: 'response' });
	}

	getAllAccessForResource(moduleName): Observable<Object> {
		return this.http.get<any>(
			`${environment.serverAPI}/api/resourceAccess/${moduleName}`).pipe(
				map(
					response => {
						let object = null;
						if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
							object = {
								read: response.data.hasRead == 'true' ? true : false,
								create: response.data.hasCreate == 'true' ? true : false,
								update: response.data.hasUpdate == 'true' ? true : false,
								delete: response.data.hasDelete == 'true' ? true : false,
								restriction: response.data.permission,
								plan: response.data.plan
							};
						} else {
							object = {
								read: false,
								create: false,
								update: false,
								delete: false,
								plan: 0,
								restriction: []
							};

							if (this.router.url.includes('/userrole/profile')) {
								object.update = true;
							} else if (this.router.url.includes('/userRole/profile')) {
								object.update = true;
							} else if (this.router.url.includes('leadDetail')
								&& moduleName == ResourceAccess.DEALS) {
								object.read = true;
							} else if (this.router.url.includes('leadDetail')
								&& moduleName == ResourceAccess.GOOGLECALENDER) {
								object.read = true;
							} else if (moduleName != 'adminNotification'
								&& !this.router.url.includes('dashboard')
								&& !this.router.url.includes('leadDetail')) {
								this.router.navigate(['/unauthorized']);
							}
						}

						return object;

					}
				)
			);
	}

	url_1 = 'https://www.calsofttech.com/ecom-gateway/ecom-svc-admin-1.0-SNAPSHOT/api';

	saveSearchKeyWords(search: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url_1}/ig/searchquery`, search);
	}

	getBrandDataByMonthAndYear(brand: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url2}/lead/details/month`, brand);
	}

	clearStorage(url?: string) {
		const cleanUrl = url ? url.split('?')[0] : '/lead';
		localStorage.removeItem(cleanUrl);
		localStorage.removeItem(cleanUrl + "se");
		localStorage.removeItem(cleanUrl + "select");
		localStorage.removeItem(cleanUrl + "type");
		localStorage.removeItem(cleanUrl + "range");
		localStorage.removeItem(cleanUrl + "selected");
		localStorage.removeItem(cleanUrl + "selectedDate");

		// Only clear advance-filter keys when targeting the lead page
		if (cleanUrl === '/lead') {
			localStorage.removeItem("advanceFilterConditionsText");
			localStorage.removeItem("advanceFilterEnble");
			localStorage.removeItem("advanceFilterConditions");
		}

	}

	upgradeText: BehaviorSubject<string> = new BehaviorSubject<string>('Add User');

	text: any;

	updateText(text) {
		this.text = text;
		this.upgradeText.next(text);
	}

	private baseUrlSubject = new BehaviorSubject<any>(localStorage.getItem('baseUrl') || '');
	baseUrl$ = this.baseUrlSubject.asObservable();

	setBaseUrl(value: any) {
		localStorage.setItem('baseUrl', value);
		this.baseUrlSubject.next(value);
	}

	getBaseUrl(): any {
		return this.baseUrlSubject.value;
	}

	setFaceBookCode(body: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url4}`, body);
	}

	setDocuSign(body: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url7}`, body);
	}

	// submitResponse(formData: any, source: any): Observable<Response[]> {
	// 	return this.http.post<Response[]>(`${this.url5}/ig/lead/capture/new/${source}?name=calsofttech.com`, formData);
	// }

	submitResponse(formData: any, source: string): Observable<Response[]> {
		const params = new HttpParams().set('name', 'calsofttech.com');

		return this.http.post<Response[]>(
			`${this.urlNew}/ig/lead/capture/new/${encodeURIComponent(source)}`,
			formData,
			{ params }
		);
	}

	saveUpdate(account: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/updateAccount`, account);
	}

	importSampleData(data: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url5}/import/sample-data`, data);
	}

	sendDocument(formData: FormData) {
		return this.http.post(this.url6 + '/docusign/sendDoc', formData, { responseType: 'text' });
	}

	setDocusignCode(body: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url6}/docusign/token`, body);
	}

	reloadCurrentRoute() {
		const currentUrl = this.router.url;
		this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
			this.router.navigate([currentUrl]);
		});
	}

	async downloadDataFinal(downLoadData, header, downloadFileName, useDefaultHeading) {
		const XLSX = await import('xlsx');

		if (this.router.url === '/lead' || this.router.url === '/companies' || this.router.url === '/deals' || this.router.url.includes('contact')) {
			downLoadData = (downLoadData || [])
				.map(record => {
					if (!record) return null;
					let downloadData = (record.downloadList != null) ? { ...record.downloadList, _rawRecord: record } : { ...record, _rawRecord: record };
					if (record.description !== undefined && record.description !== null && !downloadData.Description && !downloadData.description) {
						downloadData.Description = record.description;
					}
					return downloadData;
				})
				.filter(record => record != null);
		}

		if (Array.isArray(header) && header.length > 0 && typeof header[0] === 'string') {
			let headerRow: string[] = [...header];

			const defaultRemoved = ['leadid', 'lead_id', 'lead id', 'document', 'ownerfirstname', 'owner_firstname', 'ownerid', 'owner_id'];
			const customRemoved = (this.colummnToBeRemoved || this.colummnToBeRemoved || [])
				.map((col: string) => String(col).trim().toLowerCase().replace(/[_-\s]/g, ''));
			const removedSet = new Set<string>([...defaultRemoved, ...customRemoved]);

			headerRow = headerRow.filter(h => {
				const normH = String(h || '').trim().toLowerCase().replace(/[_-\s]/g, '');
				return !removedSet.has(normH);
			});

			const seenNormalized = new Set<string>();
			headerRow.forEach(h => {
				const norm = String(h || '').trim().toLowerCase().replace(/[_-\s]/g, '');
				if (norm) seenNormalized.add(norm);
			});

			const synonymMap: { [alias: string]: string } = {
				'leadsource': 'sourcename',
				'leadstatus': 'statusname',
				'phonenumber': 'phonenumber',
				'phoneno': 'phonenumber',
				'owneremail': 'owneremail',
				'ownerfirstname': 'owner',
				'ownername': 'owner',
				'createddate': 'createddate',
				'updateddate': 'updateddate',
				'leadid': 'entityid',
			};
			Object.keys(synonymMap).forEach(k => {
				if (seenNormalized.has(k) || seenNormalized.has(synonymMap[k])) {
					seenNormalized.add(k);
					seenNormalized.add(synonymMap[k]);
				}
			});

			(downLoadData || []).forEach(row => {
				if (!row) return;
				Object.keys(row).forEach(k => {
					if (k === '_rawRecord') return;
					const normKey = String(k || '').trim().toLowerCase().replace(/[_-\s]/g, '');
					const mappedSyn = synonymMap[normKey] || normKey;
					if (!removedSet.has(normKey) && !removedSet.has(mappedSyn) && !seenNormalized.has(normKey) && !seenNormalized.has(mappedSyn)) {
						seenNormalized.add(normKey);
						seenNormalized.add(mappedSyn);
						headerRow.push(k);
					}
				});
			});

			const defaultMapping: { [title: string]: string } = {
				'Name': 'name',
				'Email': 'email',
				'Phone No': 'phoneNumber',
				'Phone': 'phoneNumber',
				'Secondary Phone No': 'secondaryphoneno',
				'Secondaryphoneno': 'secondaryphoneno',
				'Status Name': 'statusName',
				'Source Name': 'sourceName',
				'Owner': 'ownerEmail',
				'Description': 'description',
				'Total Activity Count': 'activityCountOnLead',
				'Activity Count': 'activityCountOnLead',
				'created Date': 'createdDate',
				'updated Date': 'updatedDate',
				'Country': 'country',
				'City': 'city',
				'State': 'state',
				'Campaign Name': 'campaignName',
				'Ad Name': 'adName',
				'adName': 'adName'
			};

			const jsonHeaderKeys = headerRow.map(name => {
				const trimmedName = String(name || '').trim();
				const lowerName = trimmedName.toLowerCase();
				for (const key of Object.keys(defaultMapping)) {
					if (key.toLowerCase() === lowerName) {
						return defaultMapping[key];
					}
				}
				return name;
			});

			const dataRows = (downLoadData || []).map((row: any) => {
				return jsonHeaderKeys.map((key, index) => {
					const origHeader = headerRow[index];
					let val = this.getFieldValue(row, key, origHeader);
					return (val !== undefined && val !== null) ? val : '';
				});
			});

			const aoa = [headerRow, ...dataRows];
			const ws: any = XLSX.utils.aoa_to_sheet(aoa);
			const wb: any = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
			const filename = downloadFileName + '.xlsx';
			XLSX.writeFile(wb, filename);
			return;
		} else {
			const isFilterMetaArray = Array.isArray(header)
				&& header.length > 0
				&& typeof header[0] === 'object'
				&& header[0] != null
				&& ('property' in header[0])
				&& ('name' in header[0]);

			if (isFilterMetaArray && Array.isArray(downLoadData) && downLoadData.length > 0) {
				const fields = header
					.filter((f: any) => f && f.type !== 'disable' && f.property && f.property !== 'disable')
					.map((f: any) => ({ key: f.property, label: f.name }));

				downLoadData = downLoadData.map((row: any) => {
					const out: any = {};
					for (const f of fields) {
						out[f.label] = row?.[f.key];
					}
					return out;
				});
			}
		}

		if (this.removeColumn.length > 0) {
			downLoadData = this.removeColumn(downLoadData);
		}

		const wb = XLSX.utils.book_new();
		const ws: any = XLSX.utils.json_to_sheet([]);
		if (useDefaultHeading && header && Array.isArray(header)) {
			XLSX.utils.sheet_add_aoa(ws, Array.isArray(header[0]) ? header : [header]);
			XLSX.utils.sheet_add_json(ws, downLoadData, {
				origin: 'A2',
				skipHeader: true
			});
			XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
			const filename = downloadFileName + '.xlsx';
			XLSX.writeFile(wb, filename);
		} else {
			const ws2: any = XLSX.utils.json_to_sheet(downLoadData);
			const wb2: any = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb2, ws2, 'Sheet1');
			const filename = downloadFileName + '.xlsx';
			XLSX.writeFile(wb2, filename);
		}
	}

	getFieldValue(row: any, key: string, origHeader?: string): any {
		if (!row) return '';

		const isOwnerGroupKey = (key && key.toLowerCase().includes('owner')) || (origHeader && origHeader.toLowerCase().includes('owner'));
		if (isOwnerGroupKey && row._rawRecord) {
			const raw = row._rawRecord;
			if (raw.dealsName !== undefined || raw.dealName !== undefined || raw.dealsOwner !== undefined) {
				if (raw.dealsOwner !== undefined && raw.dealsOwner !== null && raw.dealsOwner !== '') {
					return raw.dealsOwner;
				}
				const val = row[key] || (origHeader ? row[origHeader] : '');
				const dealNameVal = raw.dealsName || raw.dealName || row['Deal Name'] || row['Deals Name'];
				if (val && dealNameVal && String(val).trim().toLowerCase() === String(dealNameVal).trim().toLowerCase()) {
					return '';
				}
				if (val) return val;
				if (raw.ownerEmail && raw.ownerEmail !== dealNameVal) return raw.ownerEmail;
				if (raw.ownerName && raw.ownerName !== dealNameVal) return raw.ownerName;
				return '';
			}
		}

		if (row[key] !== undefined && row[key] !== null && row[key] !== '') return row[key];
		if (origHeader && row[origHeader] !== undefined && row[origHeader] !== null && row[origHeader] !== '') return row[origHeader];

		const aliasGroups: { [groupName: string]: string[] } = {
			dealName: ['deal name', 'deals name', 'deal_name', 'deals_name', 'dealname', 'dealsname'],
			company: ['company', 'company name', 'company_name', 'companyname', 'account name', 'account_name', 'accountname'],
			amount: ['amount', 'deal value', 'deal_value', 'dealvalue', 'amount_value', 'amountvalue'],
			stage: ['stage', 'deal stage', 'stage name', 'deal_stage', 'stage_name', 'dealstage', 'stagename', 'statusname', 'status_name', 'status name', 'lead status', 'lead_status', 'leadstatus'],
			source: ['source name', 'source_name', 'sourcename', 'lead source', 'lead_source', 'leadsource', 'source', 'leadsource_name'],
			owner: ['sales owner', 'owner', 'deals owner', 'owner name', 'sales_owner', 'deals_owner', 'salesowner', 'dealsowner', 'owneremail', 'owner_email', 'owner email', 'owner id name', 'owneridname', 'ownerfirstname', 'owner first name', 'owner_first_name'],
			phone: ['phone number', 'phone no', 'phone_number', 'phonenumber', 'phoneno', 'phone', 'mobile'],
			secondaryPhone: ['secondary phone no', 'secondaryphoneno', 'secondary_phone_no', 'secondaryphone', 'secondary phone', 'secondary mobile'],
			closingDate: ['closing date', 'closing_date', 'closingdate'],
			expectedClosingDate: ['expected closing date', 'excepted closing date', 'expected_closing_date', 'excepted_closing_date', 'expectedclosingdate', 'exceptedclosingdate'],
			paid: ['paid'],
			balance: ['balance'],
			productName: ['product name', 'productname', 'product_name', 'product', 'item_name', 'itemname'],
			leadName: ['lead name', 'contact name', 'lead_name', 'contact_name', 'leadname', 'contactname', 'name'],
			description: ['description'],
			activityCount: ['activity count', 'activity_count', 'activitycount', 'total activity count', 'totalactivitycount', 'activitycountonlead'],
			country: ['country', 'country name', 'country_name', 'countryname'],
			city: ['city', 'city name', 'city_name', 'cityname'],
			state: ['state', 'state name', 'state_name', 'statename'],
			campaignName: ['campaign name', 'campaign_name', 'campaignname', 'ad group name', 'ad_group_name', 'adgroupname', 'source campaign'],
			adName: ['ad name', 'ad_name', 'adname', 'form name', 'form_name', 'formname'],
			createdDate: ['created date', 'createddate', 'created_date'],
			updatedDate: ['updated date', 'updateddate', 'updated_date'],
			renewalDate: ['renewal date', 'renewaldate', 'renewal_date'],
			reasonForLoss: ['reason for lost', 'reason for loss', 'reasonforloss', 'lostreason', 'reason_for_loss'],
			email: ['email', 'email address', 'emailaddress', 'email_address', 'primary email', 'primaryemail']
		};

		const normKey = String(key || '').toLowerCase().replace(/[_-\s]/g, '');
		const normOrig = origHeader ? String(origHeader || '').toLowerCase().replace(/[_-\s]/g, '') : '';

		let targetGroupKeys: string[] = [];
		let matchedGroupName: string = '';
		for (const gName of Object.keys(aliasGroups)) {
			const groupList = aliasGroups[gName];
			const match = groupList.some(alias => {
				const normAlias = alias.replace(/[_-\s]/g, '');
				return normAlias === normKey || normAlias === normOrig;
			});
			if (match) {
				targetGroupKeys = groupList;
				matchedGroupName = gName;
				break;
			}
		}

		if (targetGroupKeys.length === 0) {
			targetGroupKeys = [normKey];
			if (normOrig) targetGroupKeys.push(normOrig);
		}

		for (const rKey of Object.keys(row)) {
			if (rKey === '_rawRecord') continue;
			const normRKey = String(rKey).toLowerCase().replace(/[_-\s]/g, '');
			const isMatch = targetGroupKeys.some(alias => alias.replace(/[_-\s]/g, '') === normRKey);
			if (isMatch && row[rKey] !== undefined && row[rKey] !== null && row[rKey] !== '') {
				return row[rKey];
			}
		}

		if (row._rawRecord) {
			const raw = row._rawRecord;

			if (matchedGroupName === 'productName' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('product')))) {
				if (raw.productName !== undefined && raw.productName !== null && raw.productName !== '') return raw.productName;
				if (raw.product !== undefined && raw.product !== null && raw.product !== '') return raw.product;
				if (raw.values?.['Product Name'] !== undefined && raw.values?.['Product Name'] !== null && raw.values?.['Product Name'] !== '') return raw.values['Product Name'];
				if (raw.values?.['Product'] !== undefined && raw.values?.['Product'] !== null && raw.values?.['Product'] !== '') return raw.values['Product'];
				return '';
			}

			if (matchedGroupName === 'email' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('email') && !a.includes('owner')))) {
				if (raw.email !== undefined && raw.email !== null && raw.email !== '') return raw.email;
				if (raw.values?.['Email'] !== undefined && raw.values?.['Email'] !== null && raw.values?.['Email'] !== '') return raw.values['Email'];
				return '';
			}

			if (matchedGroupName === 'owner' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('owner')))) {
				if (raw.dealsOwner !== undefined && raw.dealsOwner !== null && raw.dealsOwner !== '') return raw.dealsOwner;
				if (raw.ownerEmail !== undefined && raw.ownerEmail !== null && raw.ownerEmail !== '') return raw.ownerEmail;
				if (raw.ownerName !== undefined && raw.ownerName !== null && raw.ownerName !== '') return raw.ownerName;
				if (raw.ownerIdName !== undefined && raw.ownerIdName !== null && raw.ownerIdName !== '') return raw.ownerIdName;
				if (raw.createdBy !== undefined && raw.createdBy !== null && raw.createdBy !== '') return raw.createdBy;
				return '';
			}

			if (matchedGroupName === 'activityCount' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('activity')))) {
				if (raw.activityCountOnLead !== undefined && raw.activityCountOnLead !== null && raw.activityCountOnLead !== '') return raw.activityCountOnLead;
				if (raw.count !== undefined && raw.count !== null && raw.count !== '') return raw.count;
				if (raw.activityCount !== undefined && raw.activityCount !== null && raw.activityCount !== '') return raw.activityCount;
				return '';
			}

			if (matchedGroupName === 'country' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('country')))) {
				if (raw.country !== undefined && raw.country !== null && raw.country !== '') return raw.country;
				if (raw.values?.['Country'] !== undefined && raw.values?.['Country'] !== null && raw.values?.['Country'] !== '') return raw.values['Country'];
				if (raw.additionalSpec?.['Country'] !== undefined && raw.additionalSpec?.['Country'] !== null && raw.additionalSpec?.['Country'] !== '') return raw.additionalSpec['Country'];
				return '';
			}

			if (matchedGroupName === 'city' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('city')))) {
				if (raw.city !== undefined && raw.city !== null && raw.city !== '') return raw.city;
				if (raw.values?.['City'] !== undefined && raw.values?.['City'] !== null && raw.values?.['City'] !== '') return raw.values['City'];
				return '';
			}

			if (matchedGroupName === 'state' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('state')))) {
				if (raw.state !== undefined && raw.state !== null && raw.state !== '') return raw.state;
				if (raw.values?.['State'] !== undefined && raw.values?.['State'] !== null && raw.values?.['State'] !== '') return raw.values['State'];
				return '';
			}

			if (matchedGroupName === 'campaignName' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('campaign')))) {
				if (raw.campaignName !== undefined && raw.campaignName !== null && raw.campaignName !== '') return raw.campaignName;
				if (raw.sourceCampaign !== undefined && raw.sourceCampaign !== null && raw.sourceCampaign !== '') return raw.sourceCampaign;
				if (raw.values?.['Ad Group Name'] !== undefined && raw.values?.['Ad Group Name'] !== null && raw.values?.['Ad Group Name'] !== '') return raw.values['Ad Group Name'];
				return '';
			}

			if (matchedGroupName === 'adName' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('ad')))) {
				if (raw.adName !== undefined && raw.adName !== null && raw.adName !== '') return raw.adName;
				if (raw.values?.['Ad Name'] !== undefined && raw.values?.['Ad Name'] !== null && raw.values?.['Ad Name'] !== '') return raw.values['Ad Name'];
				if (raw.formName !== undefined && raw.formName !== null && raw.formName !== '') return raw.formName;
				if (raw.values?.['Form Name'] !== undefined && raw.values?.['Form Name'] !== null && raw.values?.['Form Name'] !== '') return raw.values['Form Name'];
				return '';
			}

			if (matchedGroupName === 'source' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('source')))) {
				if (raw.sourceName !== undefined && raw.sourceName !== null && raw.sourceName !== '') return raw.sourceName;
				if (raw.leadSource !== undefined && raw.leadSource !== null && raw.leadSource !== '') return raw.leadSource;
				if (raw.values?.['Lead Source'] !== undefined && raw.values?.['Lead Source'] !== null && raw.values?.['Lead Source'] !== '') return raw.values['Lead Source'];
				return '';
			}

			if (matchedGroupName === 'stage' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('stage') || a.includes('status')))) {
				if (raw.statusName !== undefined && raw.statusName !== null && raw.statusName !== '') return raw.statusName;
				if (raw.stage !== undefined && raw.stage !== null && raw.stage !== '') return raw.stage;
				return '';
			}

			if (matchedGroupName === 'dealName' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('deal')))) {
				if (raw.dealsName !== undefined && raw.dealsName !== null && raw.dealsName !== '') return raw.dealsName;
				if (raw.dealName !== undefined && raw.dealName !== null && raw.dealName !== '') return raw.dealName;
				return '';
			}

			if (matchedGroupName === 'company' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('company') || a.includes('account')))) {
				if (raw.company !== undefined && raw.company !== null && raw.company !== '') return raw.company;
				if (raw.companyName !== undefined && raw.companyName !== null && raw.companyName !== '') return raw.companyName;
				if (raw.values?.['Company'] !== undefined && raw.values?.['Company'] !== null && raw.values?.['Company'] !== '') return raw.values['Company'];
				return '';
			}

			if (matchedGroupName === 'leadName' || (!matchedGroupName && targetGroupKeys.some(a => a === 'leadname' || a === 'contactname' || a === 'lead name' || a === 'contact name'))) {
				if (raw.name !== undefined && raw.name !== null && raw.name !== '') return raw.name;
				if (raw.leadName !== undefined && raw.leadName !== null && raw.leadName !== '') return raw.leadName;
				if (raw.contactName !== undefined && raw.contactName !== null && raw.contactName !== '') return raw.contactName;
				return '';
			}

			if (matchedGroupName === 'phone' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('phone') && !a.includes('secondary')))) {
				if (raw.phoneNumber !== undefined && raw.phoneNumber !== null && raw.phoneNumber !== '') return raw.phoneNumber;
				if (raw.phoneNo !== undefined && raw.phoneNo !== null && raw.phoneNo !== '') return raw.phoneNo;
				if (raw.values?.['Phone Number'] !== undefined && raw.values?.['Phone Number'] !== null && raw.values?.['Phone Number'] !== '') return raw.values['Phone Number'];
				return '';
			}

			if (matchedGroupName === 'secondaryPhone' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('secondary')))) {
				if (raw.secondaryphoneno !== undefined && raw.secondaryphoneno !== null && raw.secondaryphoneno !== '') return raw.secondaryphoneno;
				if (raw.secondaryPhoneNo !== undefined && raw.secondaryPhoneNo !== null && raw.secondaryPhoneNo !== '') return raw.secondaryPhoneNo;
				if (raw.values?.['Secondary Phone No'] !== undefined && raw.values?.['Secondary Phone No'] !== null && raw.values?.['Secondary Phone No'] !== '') return raw.values['Secondary Phone No'];
				return '';
			}

			if (matchedGroupName === 'description' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('description')))) {
				if (raw.description !== undefined && raw.description !== null && raw.description !== '') return raw.description;
				if (raw.values?.['Description'] !== undefined && raw.values?.['Description'] !== null && raw.values?.['Description'] !== '') return raw.values['Description'];
				return '';
			}

			if (matchedGroupName === 'paid' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('paid')))) {
				if (raw.paid !== undefined && raw.paid !== null && raw.paid !== '') return raw.paid;
				return '';
			}

			if (matchedGroupName === 'balance' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('balance')))) {
				if (raw.balance !== undefined && raw.balance !== null && raw.balance !== '') return raw.balance;
				return '';
			}

			if (matchedGroupName === 'createdDate' || (!matchedGroupName && targetGroupKeys.some(a => (a.includes('created') && !a.includes('by')) || a === 'date'))) {
				if (raw.createdDate !== undefined && raw.createdDate !== null && raw.createdDate !== '') return raw.createdDate;
				return '';
			}

			if (matchedGroupName === 'updatedDate' || (!matchedGroupName && targetGroupKeys.some(a => a.includes('updated') && !a.includes('by')))) {
				if (raw.updatedDate !== undefined && raw.updatedDate !== null && raw.updatedDate !== '') return raw.updatedDate;
				return '';
			}
		}

		return '';
	}

	downloadData: any = [];
	colummnToBeRemoved: any = [];

	removeColumn(downloadData) {
		this.downloadData = downloadData.map(obj => {
			for (const column of this.colummnToBeRemoved) {
				delete obj[column];
			}
			return obj;
		});
		return this.downloadData;
	}

	downloadFileAsBlob(url: string): Observable<Blob> {
		return this.http.get(url, { responseType: 'blob' });
	}
}
